import React from 'react';
import { useTranslation } from 'react-i18next';

import { TextSection } from '~/components/text-section/TextSection';

import * as S from './BullBearPoints.styles';

interface CaseAnalysisData {
  base_case: string;
  bear_case: string;
  bull_case: string;
}

interface BullBearPointsProps {
  title: string;
  data: CaseAnalysisData;
  variant?: 'primary' | 'secondary';
  useBulletPoints?: boolean;
}

export const BullBearPoints = ({
  title,
  data,
  variant = 'primary',
  useBulletPoints = true,
}: BullBearPointsProps) => {
  const { t } = useTranslation(['earnings']);

  const { bull_case, base_case, bear_case } = data;

  const cases = [
    {
      type: 'bull' as const,
      content: bull_case,
      label: t('earningsInsight.bullCase'),
    },
    {
      type: 'base' as const,
      content: base_case,
      label: t('earningsInsight.baseCase'),
    },
    {
      type: 'bear' as const,
      content: bear_case,
      label: t('earningsInsight.bearCase'),
    },
  ].filter(caseItem => caseItem.content.trim());

  if (cases.length === 0) {
    return null;
  }

  const textContent = cases.map(caseItem => (
    <React.Fragment key={caseItem.type}>
      <S.CaseHeader $variant={caseItem.type}>{caseItem.label}</S.CaseHeader>
      <span>{caseItem.content}</span>
    </React.Fragment>
  ));

  return (
    <TextSection
      title={title}
      variant={variant}
      useBulletPoints={useBulletPoints}
      textContent={textContent}
    />
  );
};
